module.exports = __webpack_public_path__ + "static/media/uprightCombined.db11682f.svg";